var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',[_c('module',[_c('settle-list'),_c('settled-list')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }